import React, { useEffect, useState } from 'react'
import Table from 'react-bootstrap/esm/Table'
import "./QualityIndicator.scss"
import { QualityData } from './QualityInitialValues'
//import { saveQualityIndicator } from "core/services/api"
import Select from "react-select"
import Button from 'react-bootstrap/esm/Button'
import moment from "moment"
import { getCenterDetails, saveQualityIndicator, getQualityIndicatorData, updateQualityIndicator } from "core/services/api"
import Toast from 'components/Toast'
import InputField from 'components/InputField'

function QualityIndicator() {

  const [allQualityData, setAllQualityData] = useState<any>()
  const [qualityId, setQualityId] = useState<any>("")
  const [qualityValues, setqualityValues] = useState<any>(QualityData);
  const [startDate, setStartDate] = useState<any>("");
  const [centerDetail, setCenterDetail] = useState<any>()
  const [centerId, setCenterId] = useState<any>()
  const [centerName, setCenterName] = useState<any>()
  const dropdownCenters = centerDetail?.map((val: any) => {
    return {
      label: val?.centerName,
      value: val?.id
    }
  })
  //Alert state values
  const [isCenterError, setIsCenterError] = useState<boolean>(false)
  const [isSuccess, setIsSuccess] = useState<boolean>(false)
  const [message, setMessage] = useState<any>("")

  useEffect(() => {
    getCenterDetails().then((res: any) => {
      setCenterDetail(res);
    }).catch((err: any) => {
      console.log(err, "error")
    })
  }, [])

  useEffect(() => {
    if (startDate && centerId) {
      const cId = centerId
      const month = moment(startDate).format("MMMM")
      const year = moment(startDate).format("YYYY")
      getQualityIndicatorData(cId, month, year)
        .then((res: any) => {
          setAllQualityData(res)
          if (res?.length > 0) {
            updateQualityDataValues(res[0])
          } else {
            setQualityId("")
            setqualityValues(QualityData)
          }
        })
        .catch((err: any) => console.log(err?.message))
    }
  }, [startDate, centerId])

  const handleChangeNumerator = ((indicatorName: any, e: any) => {
    const updatedQualityValuesNum = qualityValues.map((item: any) => {
      if (item.indicatorName === indicatorName) {
        return { ...item, numerator: Number(e.target.value) }
      }
      return item
    })
    setqualityValues(updatedQualityValuesNum);
    handleChangeOutcome(indicatorName, updatedQualityValuesNum);
  })

  const handleChangeOutcome = ((indicatorName: any, updatedQualityValues: any) => {
    const updatedOutcome = updatedQualityValues.map((item: any) => {
      if (item?.indicatorName === indicatorName && indicatorName === "patientSatisfactionIndex") {
        const result = (Number(item.numerator)) * (Number(item.multiplier))
        console.log({ result })
        return { ...item, outcome: result.toFixed(2) }
      }
      else if (item?.indicatorName === indicatorName) {
        const result = (Number(item.numerator) / Number(item.denominator)) * (Number(item.multiplier))
        console.log({ result })
        return { ...item, outcome: result.toFixed(2) }
      }
      return item
    })

    setqualityValues(updatedOutcome);

  })

  const handleChangeDenominator = ((indicatorName: any, e: any) => {
    const updatedQualityValuesDenom = qualityValues.map((item: any) => {
      if (item?.indicatorName == indicatorName) {
        return { ...item, denominator: Number(e.target.value) }
      }
      return item
    })
    setqualityValues(updatedQualityValuesDenom);
    handleChangeOutcome(indicatorName, updatedQualityValuesDenom);
  })

  const handleSaveChanges = (() => {
    if (!startDate) {
      setMessage("Please select date")
      setIsCenterError(true)
    } else if (!(centerId && centerName)) {
      setMessage("Please select center")
      setIsCenterError(true)
    } else {
      const jsonData = {
        centerId: centerId,
        centerName: centerName,
        month: moment(startDate).format("MMMM"),
        year: moment(startDate).format("YYYY"),
      } as any

      qualityValues.forEach((item: any) =>
        jsonData[item.indicatorName] = {
          numerator: item.numerator,
          denominator: item.denominator
        })

      saveQualityIndicator(jsonData)
        .then((res: any) => {
          // alert("Data added successfully");
          setMessage("Data added successfully")
          setIsSuccess(true)
          setQualityId(res?.id)

          const values = [...allQualityData]
          const index = values?.findIndex((each: any) => each?.id === res?.id)
          values[index] = res
          setAllQualityData(values)

        })
        .catch((error: any) => {
          console.log(error)
        })
    }
  })

  const handleUpdateChanges = () => {
    if (!(centerId && centerName)) {
      setMessage("Please select center")
      setIsCenterError(true)
    } else {
      const jsonData = {
        centerId: centerId,
        centerName: centerName,
        month: moment(startDate).format("MMMM"),
        year: moment(startDate).format("YYYY"),
      } as any

      qualityValues.forEach((item: any) =>
        jsonData[item.indicatorName] = {
          numerator: item.numerator,
          denominator: item.denominator
        })

      updateQualityIndicator(jsonData, qualityId)
        .then((res: any) => {
          // alert("Data added successfully");
          setMessage("Data updated successfully")
          setIsSuccess(true)
          setQualityId(res?.id)

          const values = [...allQualityData]
          const index = values?.findIndex((each: any) => each?.id === res?.id)
          values[index] = res
          setAllQualityData(values)
        })
        .catch((error: any) => {
          console.log(error)
        })
    }
  }

  const updateQualityDataValues = (centerData: any) => {
    // const qObj = allQualityData?.find((each: any) => each?.centerId === centerData?.value)
    if (centerData) {
      setQualityId(centerData?.id)
      const t1 = { ...centerData }
      delete t1["id"]
      delete t1["centerId"]
      delete t1["centerName"]
      delete t1["month"]
      delete t1["year"]
      const temp = [...qualityValues]
      Object.keys(t1).forEach((each: any) => {
        const index = temp?.findIndex((ele: any) => {
          return ele?.indicatorName === each
        })
        const foundObj = temp[index]
        const responseObj = t1[each]

        temp[index] = {
          indicator: foundObj?.indicator,
          instruction: foundObj?.instruction,
          units: foundObj?.units,
          numeratorLabel: foundObj?.numeratorLabel,
          numerator: responseObj?.numerator,
          denominator: responseObj?.denominator,
          denominatorLabel: foundObj?.denominatorLabel,
          multiplier: responseObj?.multiplier,
          indicatorName: foundObj?.indicatorName,
          outcome: responseObj?.outcome ===
            "NaN" ? 0 : responseObj?.outcome,
        }
      })
      setqualityValues(temp)
    } else {
      setQualityId("")
      setqualityValues(QualityData)
    }
  }

  function scroll() {
    const element = document.getElementById("quality-indicator-wrapper")
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <div className='quality-indicator-wrapper' id="quality-indicator-wrapper">
      {
        isCenterError ? (
          <Toast
            textMessage={message}
            onCloseText={"Close"}
            onClose={() => {
              setIsCenterError(false)
              scroll()
            }}
            type="error"
          ></Toast>
        ) : isSuccess ? (
          <Toast
            textMessage={message}
            onCloseText={"Close"}
            onClose={() => {
              setIsSuccess(false)
              scroll()
            }}
            type="success"
          ></Toast>
        ) : ""
      }
      <div className='heading'>Clinical Indicator Monitoring</div>
      <div className='sub-heading'>
        <div className="datePicker-quality">
          {/* <DatePicker
            selected={startDate}
            onChange={(date: Date) => setStartDate(date)}
            dateFormat="dd MMMM, EEEE"
            onKeyDown={(e) => {
              e.preventDefault()
            }}
          />
          <img
            src="assets/images/datepickerIcon.svg"
            style={{
              width: "40px",
              height: "35px",
              zIndex: "2",
              marginTop: "4px",
            }}
            alt=""
            className="imgCalender"
          /> */}
          <InputField
            placeholder="Select Date"
            value={startDate}
            handleChange={(e) => {
              setStartDate(e.target.value)
            }}
            type="date"
          />
        </div>

        <div>

        </div>
        <div>
          <Select
            styles={{
              control: (provided, state) => ({
                ...provided,
                border: "1px solid #ccd0e7",
                borderRadius: "10px"
              })
            }}
            className='quality-center'
            placeholder="Select Center *"
            onChange={(data: any) => {
              console.log(data, "data for center");
              setCenterId(data?.value);
              setCenterName(data?.label);
              // updateQualityDataValues(data)
            }}
            options={dropdownCenters}
          />
        </div>

      </div>

      <Table className='quality-table' striped>
        <th></th>
        <thead>
          <tr>
            <th>#</th>
            <th>Indicator</th>
            {/* <th>Instructions for Submission</th> */}
            <th>Unit</th>
            <th>Formula</th>
            <th>Input</th>
            <th>Multiplier</th>
            <th>Outcome</th>
          </tr>
        </thead>
        <tbody>

          {qualityValues?.map((val: any, index: number) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{val?.indicator}</td>
                {/* <td>{val?.instruction}</td> */}
                <td>{val?.units}</td>

                {
                  val?.indicator !== "Patient satisfaction index" ? (
                    <td>{val?.numeratorLabel}/{val?.denominatorLabel}</td>
                  ) : (
                    <td>{val?.numeratorLabel}</td>
                  )
                }
                <td>
                  <input
                    type="text"
                    placeholder="Numerator"
                    className="form-control"
                    name="numerator"
                    value={val?.numerator}
                    onChange={(e) => {
                      handleChangeNumerator(val?.indicatorName, e)
                    }}
                  />
                  {
                    val?.indicator !== "Patient satisfaction index" && (
                      <input
                        placeholder="Denominator"
                        type="text"
                        className="form-control"
                        name="denominator"
                        value={val?.denominator}
                        onChange={(e) => {
                          handleChangeDenominator(val?.indicatorName, e);
                        }}

                      />
                    )
                  }
                </td>
                <td>{val?.multiplier}</td>
                <td>{val?.outcome}</td>
              </tr>
            </>
          ))}


        </tbody>
      </Table>

      {
        !qualityId ?
          <div style={{ float: 'right', marginBottom: "50px", marginTop: '20px' }}><Button onClick={handleSaveChanges} >Save Details</Button></div>
          :
          <div style={{ float: 'right', marginBottom: "50px", marginTop: '20px' }}><Button onClick={handleUpdateChanges} >Update Details</Button></div>
      }
    </div>
  )
}

export default QualityIndicator